import { ErrorPage } from "./complaints/error-page";

export const AppErrorPage: React.FC = () => (
  <div className="font-montserrat w-full min-h-screen flex flex-col items-center justify-center bg-desktop">
    <div className="w-full grow sm:grow-0 sm:max-w-screen-sm sm:rounded-2xl bg-mobile sm:bg-none sm:bg-white sm:shadow-responsive-card px-6 py-12 flex flex-col justify-center">
      <ErrorPage />
    </div>
  </div>
);
